<template>
	<div>
		<figure class="relative z-0 tablet:rounded-GO tablet:overflow-hidden">
			<googleMap v-if="showMap" :lat="lat" :lng="lng" :address="address" :name="name" :googleMapPlaceId="googleMapPlaceId"  class="absolute z-50 inset-0" />
			<div @mouseover="showGoogleMap" @click="showGoogleMap" class="bg-[#e5e3df]">  <!-- google map background color -->
				<button class="absolute z-40 bottom-0 w-full text-center text-12 p-8 bg-white/50 device-mouse:hidden">Tap to interact</button>
				<svg-icon name="pointer" class="absolute z-30 inset-1/2 ml-[-40px] text-goPink iconSize-40 transition-opacity duration-1000" :class="[showMap ? 'opacity-0' : 'opacity-100']" />
				<goPicture v-bind="branchImage" class="relative z-20 transition-opacity duration-1000" :class="[showMap ? 'opacity-0' : 'opacity-50']"/>
				<svg-icon name="loader-mini" class="iconSize-24 text-goPink absolute z-10 inset-1/2 -ml-24 animate-backandforth duration-1000 delay-1000"  :class="[showMap ? 'opacity-100' : 'opacity-0']"/>
			</div>
		</figure>
	</div>
</template>

<script>
export default {
	inheritAttrs: false,
	components: {
		googleMap: () => import(/* webpackChunkName: "googleMap" */ "~/components/googleMap.vue"),
	},
	props: {
		name: {
			type: String,
			required: true,
		},
		address: {
			type: String,
			required: true,
		},
		lat: {
			type: Number,
			required: true,
		},
		lng: {
			type: Number,
			required: true,
		},
		googleMapPlaceId: {
			type: String,
			required: true,
		},
		slug: {
			type: String,
			required: true,
		},
	},
	data() {
		return {
			showMap: false,
		};
	},
	computed: {
		branchImage() {
			return {
				alt: "Map showing the location of the GO Rentals " + this.name + " branch",
				mobile: { src: "/images/locations/" + this.slug + "-map_Mobile.jpg", width: 375, height: 375, },
				tablet: { src: "/images/locations/" + this.slug + "-map_Tablet.jpg", width: 672, height: 672, },
				tabletWide: { src: "/images/locations/" + this.slug + "-map_Tablet.jpg", width: 456, height: 713, },
				desktop: { src: "/images/locations/" + this.slug + "-map_Tablet.jpg", width: 576, height: 576, },
				desktopWide: { src: "/images/locations/" + this.slug + "-map_Tablet.jpg", width: 656, height: 656, },
			};
		},
	},
	methods: {
		showGoogleMap() {
			this.showMap = true;
		},
	},
};
</script>
